import { useMemo } from "react";
import { openItem } from "@/store/uiSlice";
import Price from "@/components/Price";
import {
  ColumnFilled,
  ColumnFree,
  DefaultFilled,
  DefaultFree,
  MediaFilled,
  DefaultText,
  ListText,
  PriceDownText,
  PriceUpText,
  SquareMiddlePrice,
} from "../preview-widget/components";
import { useAppDispatch } from "@/hooks";
import { Content, OrderItem } from "@/types";
import { getOrderItemPrice } from "@/utils/order";
import { sanitizeNumber } from "@/utils/numbers";
import { useNavigate } from "react-router-dom";

interface ListViewProps<I extends Content> {
  items: I[];
  previewWidget: string;
}

const ListView = <I extends Content>({ items = [], previewWidget = "default-filled" }: ListViewProps<I>) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const PreviewWidget = useMemo(() => {
    switch (previewWidget) {
      case "default-text":
        return DefaultText;
      case "list-text":
        return ListText;
      case "price-down-text":
        return PriceDownText;
      case "price-up-text":
        return PriceUpText;
      case "default-filled":
        return DefaultFilled;
      case "default-free":
        return DefaultFree;
      case "column-filled":
        return ColumnFilled;
      case "column-free":
        return ColumnFree;
      case "media-filled":
        return MediaFilled;
      case "square-middle-price":
        return SquareMiddlePrice;
      default:
        return null;
    }
  }, [previewWidget]);

  return (
    <>
      {items.map((item, index) => {
        return PreviewWidget ? (
          <PreviewWidget
            key={`${item.id}-${index}`}
            title={item.title}
            description={item.previewDescription ? (item?.previewDescription as string) : item.description}
            price={<Price currency="NIO">{item.price != 0 ? getOrderItemPrice(item as unknown as OrderItem) : sanitizeNumber(item?.startingPrice)}</Price>}
            image={item?.images?.length ? item.images[0] : "/placeholder.png"}
            onClick={(e: any) => {
              e.stopPropagation();
              dispatch(openItem(item));
              navigate(`?itemId=${item.id}`);
            }}
          />
        ) : null;
      })}
    </>
  );
};

export default ListView;
